import * as React from 'react';
import AssignmentTurnedInOutlined from '@material-ui/icons/AssignmentTurnedInOutlined';
import { fetchTasksCount } from '@pec/aion-ui-core/actions/fetchTasksCount';
import { selectIsAssigneeOrg, selectIsChasContractor } from '@pec/aion-ui-core/selectors/organization';
import { ToDoDescriptor } from '../types';
import { useAppDispatch, useTypedSelector } from '../../../../combineReducers';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type RouteParams = {
  organizationId: string;
};

export const useAssignedTasksToDo = (): ToDoDescriptor[] => {
  const dispatch = useAppDispatch();
  const { organizationId } = useParams<RouteParams>();
  const { t } = useTranslation('subscriber');
  const isAssignee = useTypedSelector(selectIsAssigneeOrg);
  const isChas = useTypedSelector(selectIsChasContractor);
  const { tasks: tasksCount } = useTypedSelector(state => state.notifications);

  // The nav alerts bubble (AlertsSection) also dispatches fetchTasksCount on mount and writes to the same
  // notifications.tasks slot, so only fetch when nothing has populated it yet (`null` = not fetched) — one
  // /contractorTasks request per dashboard load, while the hook still works standalone without the nav.
  React.useEffect(() => {
    if (organizationId && !isChas && tasksCount === null) {
      dispatch(fetchTasksCount(organizationId, isAssignee));
    }
  }, [organizationId, isChas, isAssignee, tasksCount, dispatch]);

  const count = tasksCount || 0;

  return [
    {
      id: 'assignedTasks',
      variant: 'link',
      label: t('newDashboard.toDoWidget.completeAssignedTasks', 'Complete assigned tasks'),
      icon: <AssignmentTurnedInOutlined />,
      href: `/organizations/${organizationId}/alerts/tasks/all`,
      count,
      isVisible: count > 0 && !isChas,
      // notifications.tasks has no fetching flag and never contributed to the widget spinner pre-refactor.
      isFetching: false
    }
  ];
};
